import React, { useState, useRef } from 'react';
import c from 'classnames';
import styles from './ReportButton.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClickElement, InputField } from '../form';
import { ButtonMultiSwitch } from '../buttonswitch';
import { Notification } from '../notification';
import { submitItemReport } from '../../apis/dumpert';

export const ReportButton = ({ itemId }) => {
  const [voted, setVoted] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [extraInput, setExtraInput] = useState('');
  const [radioValue, setRadioValue] = useState('repost');
  const [loading, setLoading] = useState(false);
  const notificationRef = useRef();

  const clickHandler = () => {
    if (!voted) {
      setShowForm(!showForm);
    }
  };

  const submit = e => {
    e.preventDefault();
    setLoading(true);
    
    submitItemReport(
      itemId, 
      {
        reason: radioValue,
        extra: extraInput,
      })
      .then(() => {
        setExtraInput('');
        setLoading(false);
        setVoted(true);
        setShowForm(false);
        notificationRef.current.addNotification('Jouw report is verzonden', 'success');
      })
      .catch(() => {
        setLoading(false);
        setVoted(false);
        notificationRef.current.addNotification('Er gaat iets mis...', 'error');
      }); 
  };

  const buttonText = !loading 
    ? 'verzenden' : 
    <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />;

  const reportIcon = !showForm
    ? <FontAwesomeIcon icon={['fas', 'flag']} size="lg" /> 
    : <FontAwesomeIcon icon={['fas', 'times']} size="lg" />;

  const reportArticleOptions = [
    { name: 'REPOST!', value: 'repost' },
    { name: 'Dit item is NSFW', value: 'nsfw' },
    { name: 'Dit item schendt mijn privacy', value: 'privacy' },
    { name: 'Anders...', value: 'anders' },
  ];

  return (
    <>
      <Notification ref={notificationRef} />
      <div 
        className={c(
          styles['report-button'],
          {
            [styles.voted]: voted,
            [styles.close]: showForm,
          },
        )}
        onClick={clickHandler}
      > 
        {reportIcon}   
      </div>
      {showForm && (
        <div className={styles['report-form']}>
          <h3 className='display-title'>Item melden</h3>
          <form onSubmit={submit}>
            <p>Selecteer hier onder wat je wilt melden:</p>
            <ButtonMultiSwitch name="reportArticle"
              onSelect={x => { setRadioValue(x); }}
              label={''}
              options={reportArticleOptions}
              value={radioValue}
              required />
            {radioValue === 'anders' && (
              <InputField
                name="extra"
                type="text"
                placeholder={'namelijk...'}
                autoComplete="off"
                value={extraInput}
                onChange={e => setExtraInput(e.target.value)}
                autoFocus
              />
            )}
            <ClickElement
              ElementType="button"
              type="submit"
              text={buttonText}
              primary
            />
          </form>      
        </div>
      )} 
    </>
  );
}; 